import { UploadOutlined } from "@ant-design/icons";
import { Button, Upload, message } from "antd";
import type { UploadProps, RcFile } from "antd/es/upload";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { BeaconConfigFile } from "../api/models";

interface UploadFileProps {
  setConfigData: (data: BeaconConfigFile) => void;
}

export function UploadFile({ setConfigData }: UploadFileProps) {
  const { t } = useTranslation();
  const [uploadedFile, setUploadedFile] = useState<{
    name: string;
    content: any;
  } | null>(null);

  const props: UploadProps = {
    accept: ".json",
    beforeUpload: (file: RcFile) => {
      const isJson =
        file.type === "application/json" || file.name.endsWith(".json");
      if (!isJson) {
        message.error("You can only upload JSON files!");
      }
      return isJson || Upload.LIST_IGNORE;
    },
    onChange: (info) => {
      if (info.file.status !== "uploading") {
        setConfigData(uploadedFile?.content);
      }
    },
    customRequest: ({ file, onSuccess, onError }) => {
      const rcFile = file as RcFile;
      const reader = new FileReader();
      reader.onload = (e) => {
        try {
          const json = JSON.parse(e.target?.result as string);
          setUploadedFile({ name: rcFile.name, content: json });
          message.success(t("beacon:configure-success-title"));
          onSuccess && onSuccess("ok");
        } catch (err) {
          setUploadedFile(null);
          message.error(
            `${t("translations:validation-error-json")}: ${rcFile.name}`
          );
          onError && onError(err as Error);
        }
      };
      reader.readAsText(rcFile);
    },
    showUploadList: false,
  };
  return (
    <>
      <Upload {...props}>
        <Button icon={<UploadOutlined />}>
          {t("beacon:configure-upload")}
        </Button>
      </Upload>
    </>
  );
}
